export default {
  namespaced: true,
  state     : {
    modals: [
      {
        active: false,
        type  : 'company_info',
      },
    ],

  },
  getters: {
    company_info: ({modals}) => modals.find( (modal) => modal.type === 'company_info'),
  },
  mutations: {
    OPEN_MODAL(state, dialog_type) {
      let modal = state.modals.find((modal)=> modal.type === dialog_type);
      if (!modal.active) {
        modal.active = true;
      }
    },
    CLOSE_MODAL(state, dialog_type) {
      const modal =  state.modals.find((modal)=> modal.type === dialog_type);
      modal.active = false;
    },
  },
};
